import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    credits: 0
  },

  // Mutates Vue state
  mutations: {
    addCredits(state, credits) {
      state.credits += credits;
    },

    initializeCredits(state, credits) {
      state.credits = credits;
    },

    removeCredits(state, credits) {
      state.credits -= credits;
    }
  },

  // Changes Database state
  actions: {}
});
